import authAxios from '@/utils/authaxios.util';
import ServiceHandler from '@/utils/servicehandler.util';
import appconfigService from '../appconfig/appconfig.service';
import ServiceConfig from '@/config/services.config';
import { Nullable } from '@/utils/customtypes.util';
import Kiosk, { KioskBranchData } from '@/models/kiosk/kiosk.model';
import KioskResponse from '@/models/responses/kiosk-config.response';
import KioskBranchResponse from '@/models/responses/kiosk-branch-config.response';

class KioskService {
  public async getConfig(id: Nullable<string>): Promise<Kiosk> {
    try {
      const appConfig = await appconfigService.get();
      const serviceUrl = appConfig.getServiceUrl(
        ServiceConfig.KIOSK_CONFIG_GET
      );

      const resp = await authAxios
        .post(serviceUrl, {
          Data: {
            KioskId: id,
          },
        })
        .then(ServiceHandler.checkSuccess<KioskResponse>(KioskResponse))
        .catch(ServiceHandler.catchError());

      return resp.Kiosk as Kiosk;
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getBranchConfig(
    id: Nullable<number>
  ): Promise<Nullable<KioskBranchData>> {
    try {
      const appConfig = await appconfigService.get();
      const serviceUrl = appConfig.getServiceUrl(
        ServiceConfig.KIOSK_BRANCH_CONFIG_GET
      );

      const resp = await authAxios
        .post(serviceUrl, {
          Data: {
            BranchId: id,
          },
        })
        .then(
          ServiceHandler.checkSuccess<KioskBranchResponse>(KioskBranchResponse)
        )
        .catch(ServiceHandler.catchError());

      return resp.KioskBranchData as KioskBranchData;
    } catch {
      return null;
    }
  }
}

export const kioskService = new KioskService();
